import React, { useState, useRef } from "react";

export const VideoPopupWhatsappServices = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const videoRef = useRef(null);

    const handleOverlayClick = (e) => {
        if (videoRef.current && !videoRef.current.contains(e.target)) {
            setSelectedVideo(null);
        }
    };

    const videos = [
        {
            id: 1,
            src: "Assets/Images/video/WhatsApp_Quick_Services.mp4",
            // poster: "Assets/Images/video/WhatsApp_Quick_Services.png",
            poster: "https://ik.imagekit.io/gplanet/Cdat%20Website%202025/WhatsApp_Quick_Services.png",
            name: "Hon. Rohit Alka Raosaheb Katkar",
            designation: '- Sub-Regional Transport Officer'
        },
    ];

    return (
        <>
            <div className="row justify-content-center py-3">
                {videos.map((video) => (
                    <div
                        key={video.id}
                        className="col-12 col-md-4 text-center "
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedVideo(video.src)}
                    >
                        {/* <video
                            width="90%"
                            height="260px"
                            poster={video.poster}
                            muted
                            style={{
                                borderRadius: "8px",
                                objectFit: "cover",
                                // padding:'5px',
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                            }}
                        >
                            <source src={video.src} type="video/mp4" />
                        </video>
                        <div
                            style={{
                                display: "inline-block",
                                marginTop: "10px",
                                background: "rgba(240, 240, 240, 0.9)",
                                padding: "6px 16px",
                                borderRadius: "6px",
                                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.15)",
                            }}
                        >
                            <h5
                                style={{
                                    margin: 0,
                                    fontWeight: "500",
                                    color: "#333",
                                }}
                            >
                                {video.name}
                            </h5>
                        </div> */}
                        {/* Card Container */}
                        <div
                            style={{
                                width: "90%",
                                backgroundColor: "#fff",
                                borderRadius: "10px",
                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                                cursor: "pointer",
                                transition: "transform 0.2s ease",
                                marginLeft: '30px'
                            }}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.transform = "scale(1.03)")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = "scale(1)")
                            }
                        >
                            {/* Thumbnail */}
                            <video
                                poster={video.poster}
                                muted
                                style={{
                                    width: "100%",
                                    height: "220px",
                                    borderTopLeftRadius: "10px",
                                    borderTopRightRadius: "10px",
                                    objectFit: "cover",
                                }}
                            >
                                <source src={video.src} type="video/mp4" />
                            </video>

                            {/* Name below image */}
                            <div
                                style={{
                                    padding: "8px 8px",
                                    backgroundColor: "#fff",
                                    textAlign: "center",
                                    borderBottomLeftRadius: "10px",
                                    borderBottomRightRadius: "10px",
                                }}
                            >
                                <span
                                    style={{
                                        margin: 0,
                                        color: "#004080",
                                        fontWeight: "500",
                                    }}
                                >
                                    {video.name} <br />
                                    <cite className="text-muted " style={{ fontSize: '14px' }} >

                                        {video.designation}
                                    </cite>
                                </span>
                            </div>
                        </div>
                    </div>
                ))}

            </div>

            {/* Popup Overlay */}
            {selectedVideo && (
                <div
                    onClick={handleOverlayClick}
                    style={{
                        position: "fixed",
                        top: 60,
                        right: 320,
                        width: "50vw",
                        height: "90vh",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        backdropFilter: "blur(10px)", // glass effect
                        WebkitBackdropFilter: "blur(10px)", // Safari support
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        ref={videoRef}
                        style={{
                            position: "relative",
                            width: "80%",
                            maxWidth: "800px",
                            // backgroundColor: "#000",
                            background: "rgba(153, 153, 153, 0.38)",
                            backdropFilter: "blur(10px)", // glass effect
                            WebkitBackdropFilter: "blur(10px)", // Safari support
                            borderRadius: "10px",
                            overflow: "hidden",
                        }}
                    >

                        <video
                            src={selectedVideo}
                            controls
                            autoPlay
                            style={{
                                width: "50%",
                                height: "100%",
                                borderRadius: "10px",
                                marginLeft: "120px",
                            }}
                        ></video>

                        {/* Close Button */}
                        <button
                            onClick={() => setSelectedVideo(null)}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "15px",
                                color: "white",
                                fontSize: "24px",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            ✕
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};
